import { LINK } from '@constants';
import { Accordion, Button, Column, Divider, Row, Typography } from '@viewup/ui';
import { useRouter } from 'next/navigation';
import { footerInformation } from './Footer.const';

export const Footer = () => {
  const router = useRouter();

  return (
    <Column bgColor='bg.secondary' gap={16} p={20}>
      <Accordion
        items={[
          {
            content: (
              <Column gap={4}>
                {footerInformation.map((item) => (
                  <Typography color='text.assistance' fontType='body2.regular' key={item}>
                    {item}
                  </Typography>
                ))}
              </Column>
            ),
            trigger: (
              <Typography color='text.secondary' fontType='body2.medium'>
                (주)스마일드래곤
              </Typography>
            ),
            value: 'smiledragon',
          },
        ]}
        styledComponents={{
          root: {
            bgColor: 'bg.secondary',
          },
          trigger: {
            p: 0,
          },
        }}
      />
      <Divider bgColor='bg.tertiary' />
      <Row alignItems='center' gap={12}>
        <Button
          onClick={() => router.push(`${LINK.PRIVACY}?type=service`)}
          size='S'
          styledComponents={{ root: { p: 0 } }}
          variant='ghost.assistive'
        >
          이용약관
        </Button>
        <Divider height={12} orientation='vertical' />
        <Button
          onClick={() => router.push(LINK.PRIVACY)}
          size='S'
          styledComponents={{ root: { p: 0 } }}
          variant='ghost.assistive'
        >
          개인정보취급방침
        </Button>
      </Row>
    </Column>
  );
};
